import React from "react";
import "./Card.css"

const Card = ({ title, description, image, link }) => (
  <div className="card">
    
    {image && <a href={link}><img src={image} alt={title} className="card-image" /></a>}
    <div className="card-content">
      <h3><a href={link}>{title}</a></h3>
      <p>{description}</p>
      
    </div>
  </div>
);

export default Card;
